import { render, staticRenderFns } from "./resultsInvalid.vue?vue&type=template&id=4a28bcf6&scoped=true&"
import script from "./resultsInvalid.vue?vue&type=script&lang=js&"
export * from "./resultsInvalid.vue?vue&type=script&lang=js&"
import style0 from "./resultsInvalid.vue?vue&type=style&index=0&id=4a28bcf6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a28bcf6",
  null
  
)

export default component.exports